/**
 * @generated SignedSource<<94d2c6be297d2bcd25c3bce150ff72dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryPriceTable_item$data = {
  readonly canMultipleQuantityBePurchased: boolean | null;
  readonly " $fragmentType": "CheckoutMobileSummaryPriceTable_item";
};
export type CheckoutMobileSummaryPriceTable_item$key = {
  readonly " $data"?: CheckoutMobileSummaryPriceTable_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPriceTable_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryPriceTable_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canMultipleQuantityBePurchased",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "4c9879ee1d9f2ba17b6b5984babcded2";

export default node;
